import type { HealthCheckItem } from '~/types/types'
import { useSystemApi } from '~/composables/api/useSystemApi'
import type { AsyncDataOptions } from '#app'

export default defineNuxtPlugin(() => {
  const { getHealthCheck, defaultHealthCheck } = useSystemApi()

  const fetchHealthCheck = () => {
    // Cast options to satisfy useAsyncData's exact generic requirements
    const options = useAsyncDefaults() as AsyncDataOptions<HealthCheckItem>

    return useAsyncData<HealthCheckItem>(
      'useHealthCheck',
      () => getHealthCheck(),
      {
        ...options,
        default: () => defaultHealthCheck,
      }
    )
  }

  return {
    provide: {
      healthCheck: fetchHealthCheck,
    },
  }
})
